import React from 'react';

import Box from '@mui/material/Box';

import { KnzComponentProps } from '../../../types';
import { SERIF_FONT } from './proseStyle';

/**
 * 読み物の箇条書き（thoughts-ai の BulletList 相当）。
 * 各項目の先頭に「—」を付け、明朝・行高2.0 で表示する。
 * params: text（array）
 */
export const ProseList: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const rawItems = node.params.text;
  const items: string[] = Array.isArray(rawItems) ? rawItems : rawItems ? [String(rawItems)] : [];

  return (
    <Box component="ul" sx={{ pl: 2, my: 1.5, listStyle: 'none', m: 0 }}>
      {items.map((item, i) => (
        <Box
          component="li"
          key={i}
          sx={{
            fontSize: 14,
            fontFamily: SERIF_FONT,
            color: '#1A1A1A',
            lineHeight: 2.0,
            display: 'flex',
            '&::before': {
              content: '"—"',
              color: '#888',
              mr: 1,
              flexShrink: 0,
            },
            '& .wmde-markdown, & .wmde-markdown p, & .wmde-markdown span': {
              margin: 0,
              fontFamily: 'inherit',
              fontSize: 'inherit',
              lineHeight: 'inherit',
              color: 'inherit',
              background: 'transparent',
            },
          }}
        >
          <Box component="span">{renderInline(item)}</Box>
        </Box>
      ))}
    </Box>
  );
};

export default ProseList;
